module.exports = __webpack_public_path__ + "img/04_1_3_2.6d561a81.png";